import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { resourceManagerActions } from "../../constants/actionTypes";
import {
  deleteResourceError,
  deleteResourceSuccess,
  setResourceProviderListData,
  setResourceProviderListError,
  templateCreateSuccess,
  templateEditSuccess,
  setCategoryData,
  setCategoryError,
  setInstanceData,
  setInstanceError,
  setVmSnapshotData,
  setVmSnapshotError,
  setTemplateListData,
  setTemplateListError,
  setResourceConnectionData,
  addResourceAction,
  editResourceAction,
  setResourceError,
  setUploadedLogoData,
  setUploadLogoError,
  setPublishTemplateError,
  publishTemplateAction,
  setTemplateData,
  deleteTemplateSuccess,
  toggleVtEnabledSuccess,
  toggleVtEnabledError,
  setResourceProviderDetails,
  setResourceProviderError,
  templateExportError,
  templateExportSuccess,
  templateRecoverSuccess,
  templateRecoverError,
  setVMnamesList,
  setVMSnapshotNameList,
  setVMNetworksList,
  setResourceProviderListData_public,
  setResourceProviderListError_public,
  listAfterPatchPublicProvider,
  setCloudConnectLoading,
  connectCloudProviderSuccess,
  connectCloudProviderError,
  templateCreateError,
  addPublicCloudProviderError,
  addPublicCloudProviderSuccess,
  setInstanceListSearching,
  setCategoryListSearching,
  setCategoryDataInfinteScroll,
  setInstanceDataInfiniteScroll,
  resetCategoryDataInfinteScroll,
  resetInstanceDataInfinteScroll,
  setInstanceSizeSuccess,
  deleteInstanceSuccess,
  setInstanceSizeError,
  deleteInstanceError,
  publicAccountDetailsSuccess,
  publicAccountDetailsError,
  cleaningJobsSuccess,
  cleaningJobsError,
  AWSUsageSuccess,
  AWSUsageError,
  MaintenanceSessionSuccess,
  MaintenanceSessionError,
  MarkAsCleanError,
  MarkAsCleanSuccess,
} from "../actions/resourceManager";
import {
  deleteResourceProvider,
  fetchResourceProviderList,
  createTemplateApi,
  editTemplateApi,
  fetchCategory,
  fetchInstances,
  getVmSnapshot,
  fetchTemplateList,
  addResourceConnection,
  addResourceAccount,
  editResourceAccount,
  deleteTemplate,
  uploadTemplateLogo,
  publishTemplate,
  toggleVtEnabled,
  fetchResourceProviderDetails,
  templateExportApi,
  recoverTemplateApi,
  createPublicCloudProvider,
  getPublicCloudProviderListRequest,
  updatePublicCloudProvider,
  patchPublicCloudProvider,
  deletePublicCloudProvider,
  listPublicCloudTemplates,
  retrieveCloudProvider,
  deletePublicCloudTemplateRequest,
  createPublicCloudTemplateRequest,
  patchPublicCloudTemplateRequest,
  updatePublicCloudTemplateRequest,
  retrievePublicCloudTemplateRequest,
  cloudProviderConnectRequest,
  fetchInstanceWithPagination,
  setInstanceSize,
  deleteInstanceSize,
  publishPooledTemplate,
  fetchAccountDetailsListAPI,
  fetchCleaningNukeJobsAPI,
  fetchAWSUsageAPI,
  fetchMaintenanceSessionAPI,
  MarkAsCleanAPI,
} from "../api/resourceManager";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { toasterFlags } from "../../constants/componentConstants";

export function* createTemplate({ data }) {
  try {
    const createTemplateApiData = yield call(createTemplateApi, data);
    if (createTemplateApiData?.status === statusCode.Created201) {
      yield put(templateCreateSuccess(createTemplateApiData));
      yield put(setTemplateData({}));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        createTemplateApiData?.data?.message
      );
      yield put(templateCreateError(createTemplateApiData?.data || {}));
    }
  } catch (error) { }
}

export function* editTemplate({ data }) {
  try {
    const editTemplateApiData = yield call(editTemplateApi, data);
    if (
      editTemplateApiData?.status === statusCode.Created201 ||
      editTemplateApiData?.status === statusCode.Ok200
    ) {
      yield put(templateEditSuccess(editTemplateApiData));
      yield put(setTemplateData({}));
    } else {
      toastNotification(toasterFlags.ERROR, editTemplateApiData?.data?.message);
      yield put(templateCreateError(editTemplateApiData?.data || {}));
    }
  } catch (error) { }
}

export function* fetchResourceProviderListFunction({ payload }) {
  try {
    const data = yield call(fetchResourceProviderList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setResourceProviderListData(data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(setResourceProviderListError(data));
    }
  } catch (err) {
    yield put(setResourceProviderListError(err));
  }
}

export function* deleteResourceProviderFunction({ payload }) {
  try {
    const data = yield call(deleteResourceProvider, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(deleteResourceSuccess(data));
      toastNotification(
        toasterFlags.SUCCESS,
        data?.data?.success
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && data?.data?.error && (data?.data?.message || data?.data)
      );
      yield put(deleteResourceError(data));
    }
  } catch (err) {
    yield put(deleteResourceError(err));
  }
}

export function* fetchCategoryFunction({ payload }) {
  try {
    const data = yield call(fetchCategory, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setCategoryData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    yield put(setCategoryError(err));
  }
}
export function* fetchCategoryInfiniteScrollFunction({ payload }) {
  try {
    yield put(setCategoryListSearching(true));
    const data = yield call(fetchCategory, payload?.params);
    if (data?.status === statusCode.Ok200) {
      if (payload?.offset === 0 && payload?.searchName) {
        yield put(resetCategoryDataInfinteScroll(null));
        yield put(setCategoryDataInfinteScroll(data?.data));
      } else yield put(setCategoryDataInfinteScroll(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
    yield put(setCategoryListSearching(false));
  } catch (err) {
    yield put(setCategoryError(err));
    yield put(setCategoryListSearching(false));
  }
}

export function* fetchInstanceFunction({ payload }) {
  try {
    const data = yield call(fetchInstances, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setInstanceData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    yield put(setInstanceError(err));
  }
}

export function* fetchInstanceInfiniteScrollFunction({ payload }) {
  try {
    yield put(setInstanceListSearching(true));
    const data = yield call(fetchInstanceWithPagination, payload?.params);
    if (data?.status === statusCode.Ok200) {
      if (payload?.offset === 0 && payload?.searchName) {
        yield put(resetInstanceDataInfinteScroll(null));
        yield put(setInstanceDataInfiniteScroll(data?.data));
      } else {
        yield put(setInstanceDataInfiniteScroll(data?.data));
      }
    } else {
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
    yield put(setInstanceListSearching(false));
  } catch (err) {
    yield put(setInstanceListSearching(false));
    yield put(setInstanceError(err));
  }
}

export function* setInstanceSizeFunction({ payload }) {
  try {
    const response = yield call(setInstanceSize, payload);
    if (response?.status === statusCode.Created201) {
      yield put(setInstanceSizeSuccess(response?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Instance Size added successfully"
      );
    } else {
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.error && response?.data?.message
      );
      yield put(setInstanceSizeError(response?.data));
    }
  } catch (err) {
    yield put(setInstanceListSearching(false));
    yield put(setInstanceSizeError(err));
  }
}

export function* deleteInstanceSizeFunction({ payload }) {
  try {
    const response = yield call(deleteInstanceSize, payload);
    if (response?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, response?.data?.success);
      yield put(deleteInstanceSuccess(response?.data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.error && response?.data?.message
      );
      yield put(deleteInstanceError(response?.data));
    }
  } catch (err) {
    yield put(deleteInstanceError(err));
  }
}

export function* getVmSnapshotFunction({ payload }) {
  try {
    const data = yield call(getVmSnapshot, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setVmSnapshotData(data));
    } else {
      yield put(setVmSnapshotError(data));
      toastNotification(toasterFlags.ERROR, data?.data && data?.data?.message);
    }
  } catch (err) {
    yield put(setVmSnapshotError(err));
  }
}

export function* fetchTemplateListFunction({ payload }) {
  try {
    const data = yield call(fetchTemplateList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTemplateListData(data));
    } else {
      yield put(setTemplateListError(data));
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    yield put(setTemplateListError(err));
  }
}

export function* fetchTemplateFunction({ payload }) {
  try {
    const data = yield call(fetchTemplateList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTemplateData(data));
    } else {
      yield put(setTemplateListError(data));
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    yield put(setTemplateListError(err));
  }
}

export function* deleteTemplateFunction({ deleteData }) {
  try {
    const data = yield call(deleteTemplate, deleteData);
    if (data?.status === statusCode.Ok200) {
      yield put(deleteTemplateSuccess(data));
      toastNotification(
        toasterFlags.SUCCESS,
        data?.data?.success || data?.data?.Success?.[0]
      );
    } else {
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* uploadLogoFunction({ payload }) {
  try {
    const response = yield call(uploadTemplateLogo, payload);
    if (
      response?.status === statusCode.Ok200 ||
      response.status === statusCode.Created201
    ) {
      yield put(setUploadedLogoData(response));
    } else {
      toastNotification(toasterFlags.ERROR, response?.data?.file?.[0]);
      yield put(setUploadLogoError(response));
    }
  } catch (err) {
    yield put(setUploadLogoError(err));
  }
}

export function* publishTemplateFunction({ payload }) {
  try {
    const data = yield call(publishTemplate, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data.status === statusCode.Created201
    ) {
      yield put(publishTemplateAction(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setPublishTemplateError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, `${err?.message}`);
    yield put(setPublishTemplateError(err));
  }
}

export function* publishPooledTemplateFunction({ payload }) {
  try {
    const data = yield call(publishPooledTemplate, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data.status === statusCode.Created201
    ) {
      yield put(publishTemplateAction(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setPublishTemplateError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, `${err?.message}`);
    yield put(setPublishTemplateError(err));
  }
}

export function* addResourceConnectionFunction({ payload }) {
  try {
    const data = yield call(addResourceConnection, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setResourceConnectionData(data?.data));
    } else {
      toastNotification(toasterFlags.ERROR, data?.data?.message);
      yield put(setResourceError(data));
    }
  } catch (err) {
    yield put(setResourceError(err));
    toastNotification(toasterFlags.ERROR, `${err?.message}`);
  }
}

export function* addResourceAccountFunction({ payload }) {
  try {
    const data = yield call(addResourceAccount, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data.status === statusCode.Created201
    ) {
      toastNotification(toasterFlags.SUCCESS, data?.statusText);
      yield put(addResourceAction(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.data?.message}`);
      yield put(setResourceError(data));
    }
  } catch (err) {
    yield put(setResourceError(err));
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}

export function* editResourceAccountFunction({ payload }) {
  try {
    const data = yield call(editResourceAccount, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data.status === statusCode.Created201
    ) {
      yield put(editResourceAction(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.message}`);
      yield put(setResourceError(data));
    }
  } catch (err) {
    yield put(setResourceError(err));
  }
}

export function* toggleVtEnabledFunction({ payload }) {
  try {
    const data = yield call(toggleVtEnabled, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(toggleVtEnabledSuccess(data));
    } else {
      yield put(toggleVtEnabledError(data));
      toastNotification(toasterFlags.ERROR, data?.data?.message);
    }
  } catch (err) {
    yield put(toggleVtEnabledError(err));
  }
}

export function* fetchResourceProviderDetailsFunction({ payload }) {
  try {
    const data = yield call(fetchResourceProviderDetails, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setResourceProviderDetails(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.message}`);
      yield put(setResourceProviderError(data));
    }
  } catch (err) {
    yield put(setResourceProviderError(err));
  }
}

export function* templateExportRequestMainFunction({ data }) {
  try {
    const exportData = yield call(templateExportApi, data);
    if (exportData.status === statusCode.Ok200) {
      yield put(templateExportSuccess(exportData));
    } else {
      yield put(templateExportError(exportData));
      toastNotification(toasterFlags.WARN, exportData?.data?.message);
    }
  } catch (err) {
    yield put(templateExportError(err));
  }
}

export function* templateRecoverRequestFunction({ data }) {
  try {
    const recoverData = yield call(recoverTemplateApi, data);
    if (recoverData?.status === statusCode.Ok200) {
      yield put(templateRecoverSuccess(recoverData));
    } else {
      yield put(templateRecoverError(recoverData));
      toastNotification(toasterFlags.ERROR, recoverData?.data?.message);
    }
  } catch (err) {
    yield put(templateRecoverError(err));
  }
}

export function* getVCenterResourceFunction({ data }) {
  try {
    const vCenterData = yield call(getVmSnapshot, data.params);
    if (vCenterData?.status === statusCode.Ok200) {
      if (data.type === "VMNamesList") {
        yield put(setVMnamesList(vCenterData));
      } else if (data.type === "VMSnapshotsNamesList") {
        yield put(setVMSnapshotNameList(vCenterData));
      } else if (data.type === "vmNetwork") {
        yield put(setVMNetworksList(vCenterData));
      }
    } else {
      if (data.type === "VMNamesList") {
        yield put(setVMnamesList([]));
      } else if (data.type === "VMSnapshotsNamesList") {
        yield put(setVMSnapshotNameList([]));
      } else if (data.type === "vmNetwork") {
        yield put(setVMNetworksList([]));
      }
    }
  } catch (err) { }
}
export function* addPublicCloudProviderSaga({ data }) {
  try {
    const response = yield call(createPublicCloudProvider, data);
    if (response?.status === statusCode.Created201) {
      yield put(addResourceAction(response));
      yield put(addPublicCloudProviderSuccess(response));
    } else {
      yield put(setResourceError(response));
      yield put(
        addPublicCloudProviderError(
          response?.data?.error && response?.data?.message
        )
      );
      toastNotification(
        toasterFlags.ERROR,
        response?.data?.error && response?.data?.message
      );
    }
  } catch (err) {
    yield put(setResourceError(err));
    toastNotification(toasterFlags.ERROR, err);
  }
}

export function* editPublicCloudProviderSaga({ data }) {
  try {
    const response = yield call(patchPublicCloudProvider, data);
    if (response?.status === statusCode.Ok200) {
      yield put(addResourceAction(response));
      yield put(addPublicCloudProviderSuccess(response));
    } else {
      yield put(setResourceError(response));
      yield put(
        addPublicCloudProviderError(
          response?.data?.error && response?.data?.message
        )
      );

      toastNotification(
        toasterFlags.ERROR,
        (response?.data?.error && response?.data?.message) ||
        response?.data?.detail
      );
    }
  } catch (err) {
    yield put(setResourceError(err));
    toastNotification(toasterFlags.ERROR, err);
  }
}

export function* patchPublicCloudProviderSaga({ data }) {
  try {
    const response = yield call(patchPublicCloudProvider, data);
    if (response?.status === statusCode.Ok200) {
      yield put(listAfterPatchPublicProvider(response?.data));
      yield put(addPublicCloudProviderSuccess(response));
    } else {
      yield put(setResourceError(response));
      toastNotification(
        toasterFlags.ERROR,
        (response?.data?.error && response?.data?.message) ||
        response?.data?.detail
      );
    }
  } catch (err) {
    yield put(setResourceError(err));
    toastNotification(toasterFlags.ERROR, err);
  }
}

export function* deletePublicCloudProviderSaga({ payload }) {
  try {
    const response = yield call(deletePublicCloudProvider, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(deleteResourceSuccess(response));
      toastNotification(toasterFlags.SUCCESS, response?.data?.success);
    } else {
      yield put(deleteResourceError(response));
      toastNotification(toasterFlags.ERROR, response?.data?.message);
    }
  } catch (err) {
    yield put(deleteResourceError(err));
    toastNotification(toasterFlags.ERROR, err);
  }
}

export function* getPublicCloudProviderListSaga({ payload }) {
  try {
    const response = yield call(getPublicCloudProviderListRequest, payload);
    if (response?.status === statusCode.Ok200) {
      yield put(setResourceProviderListData_public(response));
    } else {
      yield put(setResourceProviderListError_public(response));
      toastNotification(toasterFlags.ERROR, response?.data?.message);
    }
  } catch (err) {
    yield put(setResourceProviderListError_public(err));
    toastNotification(toasterFlags.ERROR, err);
  }
}
export function* fetchTemplateListPublicSaga({ payload }) {
  try {
    const data = yield call(listPublicCloudTemplates, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTemplateListData(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data}`);
      yield put(setTemplateListError(data));
    }
  } catch (err) {
    yield put(setTemplateListError(err));
  }
}

export function* fetchResourceProviderDetailsFunctionPublic({ payload }) {
  try {
    const data = yield call(retrieveCloudProvider, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setResourceProviderDetails(data));
    } else {
      toastNotification(toasterFlags.ERROR, `${data?.message}`);
      yield put(setResourceProviderError(true));
    }
  } catch (err) {
    yield put(setResourceProviderError(true));
  }
}

export function* deletePublicTemplateFunction({ deleteData }) {
  try {
    const data = yield call(deletePublicCloudTemplateRequest, deleteData);
    if (data?.status === statusCode.Ok200) {
      yield put(deleteTemplateSuccess(data));
      toastNotification(
        toasterFlags.SUCCESS,
        data?.data?.success || data?.data?.Success?.[0]
      );
    } else {
      toastNotification(toasterFlags.ERROR, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.ERROR, `${err}`);
  }
}
export function* createPublicTemplate({ data }) {
  try {
    const createTemplateApiData = yield call(
      createPublicCloudTemplateRequest,
      data
    );
    if (createTemplateApiData?.status === statusCode.Created201) {
      yield put(templateCreateSuccess(createTemplateApiData));
    } else if (createTemplateApiData?.status === statusCode.BadRequest400) {
      toastNotification(
        toasterFlags.ERROR,
        createTemplateApiData?.data?.message
      );
      yield put(
        templateCreateError(
          (createTemplateApiData?.data?.error &&
            createTemplateApiData?.data?.message) ||
          {}
        )
      );
    }
  } catch (error) {
    toastNotification(toasterFlags.ERROR, error);
  }
}
export function* editPublicTemplate({ data }) {
  try {
    const editTemplateApiData = yield call(
      updatePublicCloudTemplateRequest,
      data
    );
    if (editTemplateApiData?.status === statusCode.Ok200) {
      yield put(templateEditSuccess(editTemplateApiData));
    } else {
      toastNotification(toasterFlags.ERROR, editTemplateApiData?.data?.message);
      yield put(
        templateCreateError(
          (editTemplateApiData?.data?.error &&
            editTemplateApiData?.data?.message) ||
          {}
        )
      );
    }
  } catch (error) { }
}

export function* patchPublicTemplate({ data }) {
  try {
    const editTemplateApiData = yield call(
      patchPublicCloudTemplateRequest,
      data
    );
    if (editTemplateApiData?.status === statusCode.Ok200) {
      yield put(publishTemplateAction(data));
    } else {
      toastNotification(toasterFlags.ERROR, editTemplateApiData?.data?.message);
      yield put(setPublishTemplateError(editTemplateApiData?.data));
    }
  } catch (error) {
    yield put(setPublishTemplateError(error));
  }
}

export function* getPublicTemplateDataSaga({ payload }) {
  try {
    const data = yield call(retrievePublicCloudTemplateRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setTemplateData(data));
    } else {
      yield put(setTemplateListError(data));
      toastNotification(toasterFlags.ERROR, data && data?.data);
    }
  } catch (err) {
    yield put(setTemplateListError(err));
  }
}

export function* cloudProviderConnectSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(cloudProviderConnectRequest, payload);
    if (data?.status === statusCode.Created201) {
      yield put(connectCloudProviderSuccess(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.message);
      yield put(
        connectCloudProviderError(data && data?.error && data?.message)
      );
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(setCloudConnectLoading(false));
    yield put(connectCloudProviderError({}));
  }
}

export function* fetchAccountDetailListSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(fetchAccountDetailsListAPI, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(publicAccountDetailsSuccess(data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(publicAccountDetailsError(data));
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(publicAccountDetailsError(err));
  }
}

export function* fetchCleaningJobsListSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(fetchCleaningNukeJobsAPI, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(cleaningJobsSuccess(data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(cleaningJobsError(data));
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(cleaningJobsError(err));
  }
}

export function* fetchAWSUsageListSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(fetchAWSUsageAPI, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(AWSUsageSuccess(data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(AWSUsageError(data));
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(AWSUsageError(err));
  }
}

export function* fetchMaintenanceSessionSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(fetchMaintenanceSessionAPI, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(MaintenanceSessionSuccess(data?.data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(MaintenanceSessionError(data));
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(MaintenanceSessionError(err));
  }
}

export function* MarkAsCleanSaga({ payload }) {
  try {
    yield put(setCloudConnectLoading(true));
    const data = yield call(MarkAsCleanAPI, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(MarkAsCleanSuccess(data?.data));
    } else {
      toastNotification(
        toasterFlags.ERROR,
        data && (data?.data?.message || data?.data)
      );
      yield put(MarkAsCleanError(data));
    }
    yield put(setCloudConnectLoading(false));
  } catch (err) {
    yield put(MarkAsCleanError(err));
  }
}

export function* resourceManagerRootSaga() {
  yield takeLatest(
    resourceManagerActions.RESOURCE_PROVIDER_LIST_GET_DATA,
    fetchResourceProviderListFunction
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_CREATE_REQUEST,
    createTemplate
  );
  yield takeLatest(resourceManagerActions.TEMPLATE_EDIT_REQUEST, editTemplate);
  yield takeLatest(
    resourceManagerActions.GET_CATEGORY_DATA,
    fetchCategoryFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_CATEGORY_DATA_INFINITE_SCROLL,
    fetchCategoryInfiniteScrollFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_INSTANCE_DATA_INFINITE_SCROLL,
    fetchInstanceInfiniteScrollFunction
  );
  yield takeLatest(
    resourceManagerActions.SET_INSTANCE_SIZE,
    setInstanceSizeFunction
  );
  yield takeLatest(
    resourceManagerActions.DELETE_INSTANCE_SIZE,
    deleteInstanceSizeFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_INSTANCE_DATA,
    fetchInstanceFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_VM_SNAPSHOT_DATA,
    getVmSnapshotFunction
  );
  yield takeLatest(
    resourceManagerActions.DELETE_RESOURCE_REQUEST,
    deleteResourceProviderFunction
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_LIST_GET_DATA,
    fetchTemplateListFunction
  );
  yield takeLatest(
    resourceManagerActions.ADD_RESOURCE_CONNECTION,
    addResourceConnectionFunction
  );
  yield takeLatest(
    resourceManagerActions.ADD_RESOURCE_ACCOUNT,
    addResourceAccountFunction
  );
  yield takeLatest(
    resourceManagerActions.EDIT_RESOURCE_ACCOUNT,
    editResourceAccountFunction
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_GET_DATA,
    fetchTemplateFunction
  );
  yield takeLatest(
    resourceManagerActions.DELETE_TEMPLATE_REQUEST,
    deleteTemplateFunction
  );
  yield takeLatest(resourceManagerActions.UPLOAD_LOGO, uploadLogoFunction);
  yield takeLatest(
    resourceManagerActions.PUBLISH_TEMPLATE,
    publishTemplateFunction
  );
  yield takeLatest(
    resourceManagerActions.PUBLISH_POOLED_TEMPLATE,
    publishPooledTemplateFunction
  );
  yield takeLatest(
    resourceManagerActions.TOGGLE_VT_ENABLED,
    toggleVtEnabledFunction
  );
  yield takeLatest(
    resourceManagerActions.RESOURCE_PROVIDER_GET_DETAILS,
    fetchResourceProviderDetailsFunction
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_EXPORT_REQUEST,
    templateExportRequestMainFunction
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_RECOVER_REQUEST,
    templateRecoverRequestFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_VCENTER_RESOURCES,
    getVCenterResourceFunction
  );
  yield takeLatest(
    resourceManagerActions.GET_VCENTER_RESOURCES_NETWORK,
    getVCenterResourceFunction
  );
  yield takeLatest(
    resourceManagerActions.ADD_PUBLIC_CLOUD_PROVIDER,
    addPublicCloudProviderSaga
  );
  yield takeLatest(
    resourceManagerActions.GET_PUBLIC_CLOUD_PROVIDER_LIST,
    getPublicCloudProviderListSaga
  );
  yield takeLatest(
    resourceManagerActions.EDIT_PUBLIC_CLOUD_PROVIDER,
    editPublicCloudProviderSaga
  );
  yield takeLatest(
    resourceManagerActions.PATCH_PUBLIC_CLOUD_PROVIDER,
    patchPublicCloudProviderSaga
  );
  yield takeLatest(
    resourceManagerActions.DELETE_PUBLIC_PROVIDER,
    deletePublicCloudProviderSaga
  );
  yield takeLatest(
    resourceManagerActions.GET_PUBLIC_TEMPLATE_LIST,
    fetchTemplateListPublicSaga
  );
  yield takeLatest(
    resourceManagerActions.RESOURCE_PROVIDER_GET_DETAILS_PUBLIC,
    fetchResourceProviderDetailsFunctionPublic
  );
  yield takeLatest(
    resourceManagerActions.DELETE_PUBLIC_TEMPLATE_REQUEST,
    deletePublicTemplateFunction
  );
  yield takeLatest(
    resourceManagerActions.PUBLIC_TEMPLATE_CREATE_REQUEST,
    createPublicTemplate
  );
  yield takeLatest(
    resourceManagerActions.PUBLIC_TEMPLATE_EDIT_REQUEST,
    editPublicTemplate
  );
  yield takeLatest(
    resourceManagerActions.PUBLIC_TEMPLATE_PATCH_REQUEST,
    patchPublicTemplate
  );
  yield takeLatest(
    resourceManagerActions.TEMPLATE_GET_DATA_PUBLIC,
    getPublicTemplateDataSaga
  );
  yield takeLatest(
    resourceManagerActions.CLOUD_CONNECT_PROVIDER,
    cloudProviderConnectSaga
  );
  yield takeLatest(
    resourceManagerActions.GET_ACCOUNT_DETAILS_ACTION,
    fetchAccountDetailListSaga
  );
  yield takeLatest(
    resourceManagerActions.GET_CLEANING_JOBS_ACTION,
    fetchCleaningJobsListSaga
  );
  yield takeLatest(
    resourceManagerActions.GET_AWS_USAGE_ACTION,
    fetchAWSUsageListSaga
  );
  yield takeLatest(
    resourceManagerActions.MAINTENANCE_SESSION_ACTION,
    fetchMaintenanceSessionSaga
  );
  yield takeLatest(
    resourceManagerActions.MARK_AS_CLEAN_ACTION,
    MarkAsCleanSaga
  );
}

export default function* rootSaga() {
  yield all([fork(resourceManagerRootSaga)]);
}
